import React, { useMemo } from "react";
import { useSortBy, useTable } from "react-table";
import {
    Button,
    Table,
} from "reactstrap";
import { useTranslate } from "react-translate";
import nativeSender from 'helpers/nativeSender';

const StudyAnalytes = ({ study, reportId, nativeWebView }) => {
    const t = useTranslate('laboratory-detail');

    let data = useMemo(
        //|| ('Set ID - NTE' in el)
        () => Object.keys(study).length && study.medicalValues && Array.isArray(study.medicalValues) ? study.medicalValues.map(p => {
            const tableData = {
                c1: p?.['Observation Identifier'].replace(/^([\S]{1,})\s/, ""),
                c2: p?.['Observation Value'],
                c3: p?.['Units'],
                c4: p?.['References Range'],
                c5: p?.['Abnormal Flags'],
                c6: p?.['Comment'].map((commentLine, index) => {
                    return <><p key={index}>{commentLine}</p></>
                }),
            };

            return { ...tableData };

            //}

        }) : [],
        //eslint-disable-next-line
        [study]
    );

    const columns = useMemo(
        () => [
            {
                Header: `${t('observation-identifier')}`,
                accessor: "c1",
                defaultCanSort: true
            },
            {
                Header: `${t('observation-value')}`,
                accessor: "c2",
                disableSortBy: true,
            },
            {
                Header: `${t('units')}`,
                accessor: "c3",
                disableSortBy: true,
            },
            {
                Header: `${t('references-range')}`,
                accessor: "c4",
                disableSortBy: true,
            },
            {
                Header: `${t('abnormal-flags')}`,
                accessor: "c5",
                disableSortBy: true,
            },
            {
                Header: `${t('comment')}`,
                accessor: "c6",
                disableSortBy: true,
            },
        ],
        //eslint-disable-next-line
        [study]
    );


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data, initialState: { hiddenColumns: ["c5"] } }, useSortBy);

    function base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }
    // Function will execute on click of button
    const convertPDFToUrl = () => {
        // using Java Script method to get PDF file
        var bytes = base64ToArrayBuffer(study.reportFile);
        var blob = new Blob([bytes], { type: "application/pdf" });
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        return fileURL;
    }

    return (
        <>
            {
                
                study.reportFile && (
                    <Button
                        size="md"
                        color="info"
                        href={!nativeWebView ? convertPDFToUrl() : null}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => {
                            if (nativeWebView) {
                                e.preventDefault();
                                return nativeSender.send('DOWNLOAD_REPORT', { reportId: reportId, doctorId: study.doctor_id, patientId: study.patient_id });
                            }
                        }}
                    //descomentar la siguiente linea si lo que se desea es que se descargue directamente
                    //download={reportId + ".pdf"}
                    >
                        {t('show-pdf')}
                    </Button>
                )
                
            }
            <div className="table-responsive">
                <Table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th
                                        className={`session-table-header`}
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                    >
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps((state, rowInfo) => {
                                    if (rowInfo && rowInfo.row) {
                                        return {
                                            style: {
                                                backgroundColor: rowInfo.row.values.c5 !== '' ? '#ffdddd' : '',
                                            },
                                            key: `tr-${i}`
                                        }
                                    } else return { key: `tr-${i}` }
                                })}
                                    
                                >
                                    {row.cells.map((cell, j) => {
                                        return (
                                            <td
                                                {...cell.getCellProps({key: `td-${j}-row-${i}`})}
                                            >
                                                {cell.render('Cell')}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div>
        </>
    );
};

export default StudyAnalytes;